import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
  //重定向
  {
    path: "/",
    redirect: "/main/home"
  },
  {
    path: "/main",
    redirect: "/main/home"
  },
  {
    path: "/main",
    name: "main",
    component: () => import("../pages/main/index.vue"),
    children: [
      //首页
      {
        path: "/main/home",
        name: "home",
        component: () => import("../pages/main/home.vue")
      },
      //检索结果
      {
        path: "/main/result",
        name: "result",
        component: () => import("../pages/main/result.vue")
      },
      //专利详情
      {
        path: "/main/information/:id",
        name: "information",
        component: () => import("../pages/main/information.vue")
      },
      //专利对比
      {
        path: "/main/comparison/:id1/:id2",
        name: "comparison",
        component: () => import("../pages/main/comparison.vue")
      },
      //个人中心-我的历史
      {
        path: "/personal_center/history",
        name: "history",
        component: () => import("../pages/personal_center/history.vue")
      },
      //个人中心-账户信息
      {
        path: "/personal_center/account",
        name: "account",
        component: () => import("../pages/personal_center/account.vue"),
      },
      //个人中心-我的收藏
      {
        path: "/personal_center/collection",
        name: "collection",
        component: () => import("../pages/personal_center/collection.vue"),
      }
    ]
  },
  //专利详情对比
  {
    path: "/main/informationComparison/:id",
    name: "informationComparison",
    component: () => import("../pages/main/informationComparison.vue")
  }
]
export default new Router({
  mode: 'hash',
  routes: routes
})
